import { doc, setDoc, getDoc, getFirestore } from "firebase/firestore"; 
import Auth from 'auth';
import { getQuizName, getQuestionName, saveJSONToLocal, fetchJSONFromLocal } from 'lib';
import { message } from "antd";

// todo - remove this debugging
// import demoQuizzes from 'demo_quizzes.json'
// import demoQuizzes from 'silkmandarin_quizzes.json'
// sessionStorage.setItem('quizzes', JSON.stringify(demoQuizzes))

const db = getFirestore();

function saveQuizzesLocal(quizzes) {
  saveJSONToLocal('quizzes', quizzes);
}

function fetchQuizzesLocal(quizName) {
  return fetchJSONFromLocal('quizzes');
}

function fetchQuizLocal(quizName) {
	const quizzes = fetchJSONFromLocal('quizzes');
	if (quizzes) return quizzes[quizName];
	return quizzes;
}

function fetchResponsesLocal() {
	return fetchJSONFromLocal('responses') || {};
}

function getFirstQuizName(quizzes) {
	return Object.keys(quizzes)[0]
}

function getFirstQuiz(quizzes) {
	return Object.values(quizzes)[0]
}

function getFirstQuizQuestion(quiz) {
  return Object.values(quiz)[0];
}

function getFirstQuizQuestionName(quiz) {
  return Object.keys(quiz)[0];
}

function __hasQuestion(selectedQuestion, questions) {
  return selectedQuestion in questions;
}

function saveImageUploads(question) {
  Object.keys(question).forEach((key) => {
    const toolBoxTool = question[key];
    if ('mediaFiles' in toolBoxTool) {
      toolBoxTool.mediaFiles.forEach((mediaFile) => {
        if (mediaFile.file) {
          console.log('uploading question file: ', mediaFile.file);
          Storage.uploadFile(mediaFile.file, (downloadURL) => {
            mediaFile.src = downloadURL;
          });
        } else {
          delete mediaFile.file
        }
      });
    }
  });
}

function getNearest(items, selectedItem) {
	const keys = Object.keys(items);
  const indexOfSelectedItem = keys.indexOf(selectedItem);
  if (indexOfSelectedItem > 0) {
		return keys[indexOfSelectedItem-1];
  } else {
		return keys[indexOfSelectedItem+1];
  }
}

export default class QuizDB {
	static async saveQuestions(quizName, questions, onSuccess=()=>{}, onError=()=>{}) {
		console.log('saving questions to firestore')

		try {
			const auth = Auth.getAuth();
			const docid = auth.user.email;
			const data = {[quizName]: questions};
			await setDoc(doc(db, "quizzes", docid), data);
		  onSuccess();
		} catch (error) {
		  QuizDB.handleErrors(error, onError)
		}
	}

	static async saveQuizzes(quizzes, onSuccess=()=>{}, onError=()=>{}) {
		console.log('saving quizzes to firestore')

		try {
			const auth = Auth.getAuth();
			const docid = auth.user.email;
			await setDoc(doc(db, "quizzes", docid), quizzes, { merge: false });
		  onSuccess();
		} catch (error) {
		  QuizDB.handleErrors(error, onError)
		}
	}

	static handleErrors(error, onError) {
		switch(error.code) {
			case 'permission-denied':
				const msg = 'user session expired, please wait'
				console.error(msg, error.toString());
				onError(msg);
				Auth.deAuth();
				message.warn(msg);
				setTimeout(()=>window.location.reload(), 3500);
				break;
			default:
				console.error("unknown error: ", error.toString());
				onError(`take a screenshot: "${error.toString()}"`)
		}
	}

	static async loadQuizzes(onSuccess, onError) {
		console.log('loading quizzes from firestore')

		try {
			const auth = Auth.getAuth();
			const docid = auth.user.email;
			const docSnap = await getDoc(doc(db, "quizzes", docid));
			if (docSnap.exists()) {
				const questions = docSnap.data();
			  onSuccess(questions)
			} else {
				const message = 'quiz not found'
			  console.error(message);
			  onError(message)
			}
		} catch (error) {
		  console.error("fetching quizzes from db: ", error.toString());
		  onError(error)
		}
	}

	static async loadQuestions(onSuccess, onError) {
		console.log('loading questions from firestore')

		try {
			const auth = Auth.getAuth();
			const docid = auth.user.email;
			const docSnap = await getDoc(doc(db, "quizzes", docid));
			if (docSnap.exists()) {
				const questions = docSnap.data();
			  console.log("questions data:", questions);
			  onSuccess(questions)
			} else {
				const message = 'questions not found'
			  console.error(message);
			  onError(message)
			}
		} catch (error) {
		  console.error("fetching questions from db: ", error.toString());
		  onError(error)
		}
	}

	static async saveStudentResponse(studentInfo, quizName, responses, onSuccess=()=>{}, onError=()=>{}) {
		console.log('saving responses to firestore')

		try {
			let docid;
			const auth = Auth.getAuth();
			if (auth !== undefined && auth !== null) {
				docid = auth.user.email;
			} else {
				docid = process.env.REACT_APP_ADMIN_EMAIL;
			}
			const { name, email } = studentInfo;
			const data = {
				[quizName]: {
					[email]: {
						name,
						responses,
					}
				}
			}
			await setDoc(doc(db, "responses", docid), data, { merge: true });
			console.log('successfully saved responses to firestore');
		  onSuccess();
		} catch (error) {
		  QuizDB.handleErrors(error, onError)
		}
	}

	static async loadResponses(onSuccess, onError) {
		console.log('loading responses from firestore')

		try {
			const auth = Auth.getAuth();
			const docid = auth.user.email;
			const docSnap = await getDoc(doc(db, "responses", docid));
			if (docSnap.exists()) {
				const questions = docSnap.data()[getQuizName()];
			  console.log("response data:", questions);
			  onSuccess(questions)
			} else {
				const message = 'responses not found'
			  console.error(message);
			  onError(message)
			}
		} catch (error) {
		  console.error("fetching responses from db: ", error.toString());
		  onError(error)
		}
	}
}

export {
	QuizDB,
	saveQuizzesLocal,
	fetchQuizzesLocal,
	getFirstQuizName,
	getFirstQuiz,
	getFirstQuizQuestion,
	getFirstQuizQuestionName,
	getNearest,
	saveImageUploads,
	fetchQuizLocal,
	fetchResponsesLocal,
}
